module.exports = __webpack_public_path__ + "static/media/28F5CFFF-3C3F-44EE-A27D-66450323A841.9bcbcf7e.JPG";